import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Button, Form } from "react-bootstrap";
import { Flag } from "react-feather";
import getOnboardingStages from "../../utils/onboardingStages";
import Spinner from 'react-bootstrap/Spinner';

const { REACT_APP_BACKEND_URL } = process.env;


const OnboardingDisclosures = ({stage, token, data}) => {
  const initialValues = {disclosures:[]}

  if (data && data.disclosures)
  {
    for (let i = 0; i < data.disclosures.length; i++)
    {
      if (data.disclosures[i].explanation == null)
      {
        data.disclosures[i].explanation = "";
      }

      initialValues.disclosures.push(data.disclosures[i]);
    }
  }

  let onboardingStages = getOnboardingStages(data.preferences);

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={Yup.object().shape({
        disclosures: Yup.array().of(
          Yup.object().shape({
            answer: Yup.string().oneOf(["YES", "NO"]).nullable().required("Please select an answer"),
            explanation: Yup.string().max(1027).when("answer", {
              is: "YES",
              then: Yup.string().required("Explanation is required"),
              otherwise: Yup.string()
            }),
          })
        )
      })}
      onSubmit={async (values, { setErrors, setStatus, resetForm, setSubmitting }) => {
        try {
          let formData = new FormData();

          formData.append("data", new Blob([JSON.stringify(
            {
              disclosures: values.disclosures
            })], {
              type: "application/json"
          }));

          const requestMetadata = {
            method: 'POST',
            body: formData
          };

          const res = await fetch(REACT_APP_BACKEND_URL + "onboarding/" + stage + "/" + token, requestMetadata);

          if (res.status >= 200 && res.status <= 299)
          {
            setStatus({success: true})

            window.location = "/onboarding/" + onboardingStages[onboardingStages.indexOf(stage) + 1] + "/" + token
          }
          else if (res.status === 400)
          {
            setStatus({ success: false });
            alert("Unable to submit; please disable any ad blockers and/or antivirus software and try again. If the problem persists, using a different browser may help.");
            setSubmitting(false);
          }
          else
          {
            throw Error(res.statusText);
          }
        } catch (error) {
          const message = "Something went wrong; please try again";

          setStatus({ success: false });
          alert(message);
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        status,
        touched,
        values,
        getFieldProps,
      }) => (
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <ol>
            <Form.Label style={{fontWeight: "bold"}}>Disclosures*
            <br /><span style={{fontSize: '0.9em', fontWeight: "normal"}}><Flag style={{height: "16px", width: "16px", color: "#2B7A78"}} /> Please answer the following Yes / No questions. If yes, please provide additional information.</span>  
            </Form.Label><br />
            {values.disclosures.map((disclosure, index) => {
              let showHeader = index === 0 || values.disclosures[index - 1].header !== disclosure.header;

              return (
                <React.Fragment key={disclosure.id}>
                {showHeader && <><br /><Form.Label style={{fontWeight: "bold"}}>{disclosure.header}</Form.Label></>}
                <li>{disclosure.question}
                <br />
                <Form.Check style={{display: "inline"}}
                  type="radio"
                  onChange={(e) => {
                    setFieldValue(`disclosures[${index}].answer`, "YES");
                  }}
                  onBlur={handleBlur}
                  checked={disclosure.answer === 'YES'}
                  name={`disclosures[${index}].answer`}
                  isInvalid={!!touched.disclosures?.[index]?.answer && !!errors.disclosures?.[index]?.answer}
                />&nbsp;Yes&nbsp;&nbsp;
                <Form.Check style={{display: "inline"}}
                  type="radio"
                  onChange={(e) => {
                    setFieldValue(`disclosures[${index}].explanation`, "", false);
                    setFieldValue(`disclosures[${index}].answer`, "NO");
                  }}
                  onBlur={handleBlur}
                  checked={disclosure.answer === 'NO'}
                  name={`disclosures[${index}].answer`}
                  isInvalid={!!touched.disclosures?.[index]?.answer && !!errors.disclosures?.[index]?.answer}
                />&nbsp;No
                </li>
                {!!touched.disclosures?.[index]?.answer && errors.disclosures?.[index]?.answer && (
                  <Form.Control.Feedback style={{ display: "block" }} type="invalid">
                    {errors.disclosures?.[index]?.answer}
                  </Form.Control.Feedback>
                )}
                {disclosure.answer === 'YES' &&
                  <>
                  <Form.Control
                    as="textarea"
                    style={{marginTop: "5px"}}
                    placeholder="Please provide additional details"
                    {...getFieldProps(`disclosures[${index}].explanation`)}
                    isInvalid={Boolean(touched.disclosures?.[index]?.explanation && errors.disclosures?.[index]?.explanation)}
                  />
                  {!!touched.disclosures?.[index]?.explanation && errors.disclosures?.[index]?.explanation && (
                    <Form.Control.Feedback type="invalid">
                      {errors.disclosures?.[index]?.explanation}
                    </Form.Control.Feedback>
                  )}
                  </>
                }
                <br />
                </React.Fragment>
            );
            })}
            </ol>
          </Form.Group>
          <br />
          {isSubmitting ?
          <div className="text-center">
             <br />
            <Spinner size="sm" animation="border" />
          </div>
          :
          <>
            <div className="text-center mt-3 float-start">
              <Button size="lg" className="btn-secondary" onClick={() => {window.location = "/onboarding/" + onboardingStages[onboardingStages.indexOf(stage) - 1] + "/" + token}}>Back</Button>
            </div>
            <div id="submitButton" className="text-center mt-3 float-end">
              <Button
                type="submit"
                variant="primary"
                size="lg"
                disabled={isSubmitting}  // Don't check touched, otherwise you end up with this button disabled for, e.g. a peer reference first name missing that has never been touched, so it's not in red; let them click this to touch everything
              >
                Save and Continue
              </Button>
            </div>
          </>
          }
          <br /><br /><br />
          {
            Object.keys(errors).length > 0 && Object.keys(touched).length > 0 &&
            <div className="text-center mt-3"><span className="invalid-feedback" style={{display: "inline-block"}}>Please correct the errors above before moving forward</span></div>
          }
        </Form>
      )}
    </Formik>
  );
}

export default OnboardingDisclosures;
